import CircularProgress from '@mui/material/CircularProgress';
import { Center } from './Center';

export function Loading() {
  return (
    <Center sx={{ width: '100%', height: '100vh' }}>
      <CircularProgress />
    </Center>
  );
}
